var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5703 16.0273C29.5703 23.7684 23.4405 30.0511 15.8725 30.0511C8.30454 30.0511 2.1748 23.7684 2.1748 16.0273C2.1748 8.27909 8.30454 2.00342 15.8725 2.00342C23.4405 2.00342 29.5703 8.27909 29.5703 16.0273Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2927 12.4786C22.218 12.5233 20.4386 13.4654 20.4386 15.5543C20.5225 17.9366 22.6841 18.7721 22.7212 18.7721C22.6841 18.8167 22.3948 19.9102 21.538 21.0564C20.8579 22.0437 20.1032 23.0392 18.957 23.0392C17.8668 23.0392 17.4754 22.3812 16.2175 22.3812C14.8665 22.3812 14.4843 23.0392 13.45 23.0392C12.3038 23.0392 11.4931 21.9904 10.776 21.0123C9.84442 19.7322 9.05257 17.7233 9.02462 15.7943C9.00578 14.7722 9.21118 13.7675 9.7326 12.914C10.4685 11.7226 11.7824 10.9138 13.2172 10.8871C14.3165 10.8518 15.295 11.6072 15.9659 11.6072C16.6088 11.6072 17.8109 10.8871 19.1709 10.8871C19.758 10.8877 21.3234 11.0564 22.2927 12.4786ZM15.8729 10.6831C15.6772 9.74963 16.2175 8.81619 16.7206 8.22076C17.3636 7.50068 18.3791 7.01193 19.2548 7.01193C19.3107 7.94537 18.9564 8.86083 18.3232 9.52757C17.755 10.2477 16.7766 10.7897 15.8729 10.6831Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d1add5368d3c2a07598c0c5d9170272c.svg";
export { ForwardRef as ReactComponent };